import Vue from "vue"
import Vuex from "vuex"
import Cookies from "js-cookie"
// import routerData from "./modules/routerData"
// import role from "./modules/role"
// import layout from "./modules/layout/index"

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    username: Cookies.get("username"),
    token: Cookies.get("access_token")
  },
  mutations: {
    setToken (state, token, username) {
      state.token = token;
      state.username = username;
      Cookies.set("access_token", token, { expires: 7 });
      Cookies.set("username", username);
    },
  },
  actions: {
    setToken ({commit}, token) {
      return new Promise((resolve) => {
        commit("setToken", token);
        resolve();
      })
    },
    removeToken () {
        Cookies.remove("access_token");
        Cookies.remove("username");
        this.state.token = null;
        this.state.username = null;
    },
  },
  getters: {
    // addRouters: state => state.routerData.addRouters,
    // roleData: state => state.routerData.roleData,
    token: state => state.token,
    isLoggedIn: state => !!state.token,
    // info: state => state.role.info,
    // routers: state => state.routerData.routers,
    // logoShow: state => state.layout.logoShow,
    // isCollapse: state => state.layout.isCollapse,
    // uniquerouter: state => state.layout.uniquerouter,
    // tabnavBox: state => state.layout.tabnavBox,
    // visible: state => state.layout.visible,
    // left: state => state.layout.left,
    // top: state => state.layout.top,
    // rightNav: state => state.layout.rightNav
  },
//   modules: {
//     // routerData,
//     role,
//     layout
//   }
})

export default store;